'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import { useProgress } from '@/app/hooks/useProgress';
import { ProgressBar } from '../ProgressBar';

const ProgressContext = createContext<ReturnType<typeof useProgress> | undefined>(undefined);

export const useProgressContext = () => {
  const context = useContext(ProgressContext);
  if (!context) {
    throw new Error(
      'useProgressContext must be called within ProgressContext',
    );
  }
  return context;
};

export const ProgressProvider = ({
  children,
  total,
}: PropsWithChildren<{
  total: number;
}>) => {
  const value = useProgress({ total });

  return (
    <ProgressContext.Provider value={value}>
      {total !== 0 && <ProgressBar />}
      {children}
    </ProgressContext.Provider>
  );
};
